<h3 mat-dialog-title>{{data.selectedItem.ProductId}} - {{data.selectedItem.ProductDescription}}</h3>
<mat-dialog-content >
    {{data.message}}
    <mat-form-field>
        <mat-label>Price/Unit </mat-label>
        <input class="ta-itemdetails-priceunit" matInput name="price" min="0" type="number"
          onKeyPress="if((this.value.length==14 && this.value.indexOf('.') > -1) || this.value.length == 13) return false;"
          onlyNumber="true" placeholder="" [(ngModel)]="data.selectedItem.Price" [disabled]="data.selectedItem.IsPriceOveridden"
          (input)="checkInput($event,data.selectedItem);">
      </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="text-right">
        <button mat-button class="magin_5 text-white btn btn-success" [disabled]="data.selectedItem.Price==null || data.selectedItem.Price == 0"  (click)="onPositiveClick()" cdkFocusInitial>{{data.positiveKey}}</button>
        <button mat-button mat-button class="magin_5 text-white btn btn-danger"  (click)="onNoClick()">Close</button>
    </div>
</mat-dialog-actions>